var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"background"}},[_c('div',{staticClass:"background__container",class:{'background__container--beating': _vm.isMasked}},[_c('div',{staticClass:"background__canvas",class:{'background__canvas--masked': _vm.isMasked, 'background__canvas--fixed': _vm.isFixed}},[_c('div',{ref:"shader",staticClass:"background__shader"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }